import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {UpsellForm} from "../forms";
import {upsellService} from "../../services";
import {forms, strings} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";

const toData = (upsell) => {
    return {
        name: upsell.name,
        description: upsell.description,
        landingPageUrl: upsell.landingPageUrl,
        price: upsell.price,
        order: upsell.order,
        valid: strings.isNotBlank(upsell.name) && sortingUtils.isSortable(upsell.order),
    }
};

const EditUpsellDialog = (props) => {
    const { snackbar, upsell, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(upsell));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.name + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const modified = {
            name: data.name,
            description: data.description,
            landingPageUrl: data.landingPageUrl,
            price: data.price,
            order: data.order,
        };

        upsellService.saveUpsell(upsell.id, modified, success, failure);
    }

    return <Dialog
        open={true}
        aria-labelledby="edit-upsell-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Edit Upsell
        </ClosableDialogTitle>
        <DialogContent className="edit-upsell-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <UpsellForm
                    data={data}
                    onChange={setData}
                    showOrder={true}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(toData(upsell), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default EditUpsellDialog;
